import { connect } from 'react-redux';
import ConversationDetailsComponent from '../components/conversation_details';
import ConversationDetailsActions from '../actions/conversation_details';
import ConversationActions from '../actions/conversation';

function mapStateToProps(state) {
  const users = state.activeConversation.id
    ? state.activeConversation.participants.map(participant => {
        return participant.user;
      })
    : [];

  return {
    display: state.conversationDetails.visible,
    conversationId: state.activeConversation.id,
    users: users
  };
}

const ConversationDetailsContainer = connect(
  mapStateToProps,
  {
    close: ConversationDetailsActions.close,
    archive: ConversationActions.archive
  }
)(ConversationDetailsComponent);

export default ConversationDetailsContainer;
